module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAMAAAAI/bVFAAAAM1BMVEUAAAAUVOsUVOwQUO8TU+wUU+sUVOwQVe8TU+wTU+wTVOwTVOwTUuwQUO8TU+wTU+wUVOxBoQbxAAAAEHRSTlMAQIAQoNC/MJBQ8LBfIODfL/JorQAAAFhJREFUCNdFzdEOgCAIheEjWGhq9f5PW4dg/Re4b7AJr27KJ3AcZG66cBvQIpwBvApWhQvNwFxRl04tmQsYQyZl0k7F/V/W8kmNUygvpQletmvP+L2VDHgAuK4B7FfJ6cYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/uploading.png
// module id = 94JG
// module chunks = 1 5